<template>
  <div class="student-manage">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" type="primary" size="medium" @click.native="exportExcel">导出</el-button>
        <advanced-query @search="search" />
      </div>
      <div class="fr">
        <el-input
          v-model.trim="searchFormData.query"
          placeholder="学员姓名/证件号码"
          @keypress.enter.native="() => search()"
        ></el-input>
        <el-date-picker
          v-model="date"
          class="m-r-10"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button @click="() => search()" type="primary">查询</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:name="row">
        <el-button type="text" size="small" @click="openInf(row)">{{ row.name }}</el-button>
      </template>
    </ly-table>
    <student-info ref="studentInfo" :contact_id="curItem.contact_id" />
  </div>
</template>

<script>
import { Input, DatePicker } from 'element-ui';
import utils from '@/utils/utils';
import LyTable from '@/components/LyTable';
import { studentTable } from '@/utils/tableHeader';
import StudentInfo from '@/components/StudentInfo';
import AdvancedQuery from '@/components/AdvancedQuery';

import { contact } from '@/api';

export default {
  name: 'StudentMange',
  components: {
    LyTable,
    ElInput: Input,
    StudentInfo,
    AdvancedQuery,
    ElDatePicker: DatePicker

  },
  data() {
    return {
      searchFormData: {
        query: ''
      },
      date: [],
      tableHeader: Object.freeze(studentTable),
      getTableData: contact.getStudent,
      curItem: {}
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search(data) {
      this.searchFormData = {
        ...this.searchFormData,
        ...data
      };
      if (this.date && this.date.length) {
        this.searchFormData = {
          ...this.searchFormData,
          // start_time: this.date && this.date.length ? `${this.date[0]} 00:00:00` : -1,
          // end_time: this.date && this.date.length ? `${this.date[1]} 23:59:59` : -1,
          start_time: this.date[0],
          end_time: this.date[1],
          ...data
        };
      } else {
        delete this.searchFormData.start_time;
        delete this.searchFormData.end_time;
      }
      this.$refs.lyTable.setData();
    },
    openInf(row) {
      this.curItem = { ...row };
      this.$refs.studentInfo.open();
    },
    exportExcel() {
      contact
        .exportStudent({
          params: this.searchFormData
        })
        .then(data => {
          if (data) utils.downloadData(data, '学员列表');
        });
    }
  }
};
</script>

<style lang="less">
.student-manage {
  .hd {
    overflow: hidden;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .base-inf {
    list-style: none;
    li {
      float: left;
      overflow: hidden;
      margin: 10px;
      > span {
        font-weight: 600;
        display: inline-block;
        width: 100px;
        margin-right: 10px;
      }
      > i {
        font-style: normal;
        display: inline-block;
        min-width: 200px;
      }
    }
  }
}
</style>
